
let firebaseConfig;

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    // Local development configuration
    console.log("Using Development Firebase Project.");
    firebaseConfig = {
      apiKey: "AIzaSyDdnSVQMgZlE1Ud-3oFD8XhH55fXTwAeQo",
      authDomain: "mad-dev-d337b.firebaseapp.com",
      projectId: "mad-dev-d337b",
      storageBucket: "mad-dev-d337b.firebasestorage.app",
      // messagingSenderId: "541567371496",
      appId: "1:541567371496:web:2945d58c7737977d34615d",
      // measurementId: "G-0V9SN5QK79"
    };

  } else {
    // Production configuration
    console.log("Using Production Firebase Project.");
    firebaseConfig = {
        apiKey: "AIzaSyCkCl2INEKwfG1LHBsR35rUFCQGqfoLdug",
        authDomain: "methodaday.firebaseapp.com",
        projectId: "methodaday",
        storageBucket: "methodaday.appspot.com",
        // messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
        appId: "methodaday"
    };
}
// // This should match the config you copied from your Firebase Project Settings -> Web App
// const firebaseConfig = {
//     apiKey: "AIzaSyCkCl2INEKwfG1LHBsR35rUFCQGqfoLdug",
//     authDomain: "methodaday.firebaseapp.com",
//     projectId: "methodaday",
//     storageBucket: "methodaday.appspot.com",
//     // messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
//     appId: "methodaday"
//   };
  console.log("Firebase Config:", firebaseConfig);
  export default firebaseConfig;